module.exports = __webpack_public_path__ + "static/media/ic_video_tag.3bdf6e73.svg";